import enrollmentQuery from "./enrollmentQuery";

const enrollmentQueryService = [
    {
        matcher: 'enrollmentQuery',
        reply: config => {
            return [200, enrollmentQuery];
        }
    }
]

export default enrollmentQueryService;